import { render, staticRenderFns } from "./w-select.vue?vue&type=template&id=3fe97071&scoped=true"
import script from "./w-select.vue?vue&type=script&lang=ts"
export * from "./w-select.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe97071",
  null
  
)

export default component.exports